import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Contact from '@/views/Contact'
import Download from '@/views/Download'
import News from '@/views/News'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/download',
    name: 'Download',
    component: Download
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '*',
    redirect: '/'
  }
  ]
})
